import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BrapiSyncContextService } from '../brapi-sync-context.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DropdownVirtualScrollResult } from '../shared/dropdown-virtual-scroll/dropdown-vritual-scroll.component';
import { AlertService } from '../../shared/alert/alert.service';
import { BrapiSyncPath, BrapiSyncService } from '../brapi-sync.service';

declare const BrAPI: any;

@Component({
    selector: 'app-program',
    templateUrl: './program.component.html',
    styleUrls: ['./program.component.css']
})
export class ProgramComponent implements OnInit {
    loading = false;
    sourcePrograms: any[] = [];
    targetPrograms: any[] = [];
    brapiSource: any;
    brapiDestination: any;

    constructor(
    private router: Router,
    public context: BrapiSyncContextService,
    private alertService: AlertService,
    private brapiSyncService: BrapiSyncService
    ) {
        this.brapiSource = BrAPI(this.context.source, '2.0', this.context.sourceToken);
        this.brapiDestination = BrAPI(this.context.destination, '2.0', this.context.destinationToken);
    }

    brapiSourcePrograms = (page: number) => {
        return new Promise<DropdownVirtualScrollResult | null>(resolve => {
            this.brapiSource.programs({
                pageRange: [page, page + 1],
            }).all((items: any[]) => {
                if (items.length) {
                    resolve(this.createDropdownVirtualScrollResult(items));
                } else {
                    resolve(null);
                }
            });
        });
    };

    brapiDestinationPrograms = (page: number) => {
        return new Promise<DropdownVirtualScrollResult | null>(resolve => {
            this.brapiDestination.programs({
                pageRange: [page, page + 1],
            }).all((items: any[]) => {
                if (items.length) {
                    resolve(this.createDropdownVirtualScrollResult(items));
                } else {
                    resolve(null);
                }
            });
        });
    };

    createDropdownVirtualScrollResult(items: any[]): DropdownVirtualScrollResult {
        const pageSize = items[0].__response.metadata.pagination.pageSize;
        const totalCount = items[0].__response.metadata.pagination.totalCount;
        const totalPages = items[0].__response.metadata.pagination.totalPages;
        return { items, pageSize, totalCount, totalPages };
    }

    ngOnInit(): void {
        this.alertService.closeAllAlerts();
    }

    async next(): Promise<void> {
        this.brapiSyncService.navigateToPage(BrapiSyncPath.EntitySelector);
    }

    back(): void {
        this.brapiSyncService.navigateToPage(BrapiSyncPath.Connections);
    }

    onError(res: HttpErrorResponse): void {
        this.alertService.error('brapi-sync.program.error.cannot-load-programs');
    }
}
